<template>
  <b-row>
    <b-col md="4">
      <label>Fecha de firma*</label>
    </b-col>
    <b-col md="8">
      <b-form-datepicker
        v-model="fechaFirma"
        locale="es-ES"
        :disabled="disabled"
        :min="fechaOferta"
        :start-weekday="1"
      />
    </b-col>
  </b-row>
</template>

<script>
import { formatDateForm, formatDateSinZona, formatDateAddDaysForm } from "@/services/date";
import * as Plazos from "@/enums/Plazos";
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import { useTrazabilidadStore } from "@/stores/trazabilidad";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta"]),
    ...mapState(useTrazabilidadStore, ["fechaFirmaContratoInicial"]),
    fechaFirma: {
      get() {
        if (!this.oferta.fechaFirmaContrato) {
          return formatDateForm(formatDateAddDaysForm(new Date(), Plazos.DIASPARAFIRMACONTRATO));
        }
        let fechaLimpia = formatDateSinZona(this.oferta.fechaFirmaContrato);
        return formatDateForm(fechaLimpia);
      },
      set(value) {
        this.oferta.fechaFirmaContrato = value;
      },
    },
    fechaOferta() {
      let fechaLimpia = formatDateSinZona(this.oferta.fecha);
      return formatDateForm(fechaLimpia);
    },
  },
};
</script>
